import ArticleProgressBar from './articleProgressBar'

const articleProgressBar = new ArticleProgressBar()
articleProgressBar.init()
